import React, { memo, useEffect, useState } from "react";
import { MDBIcon } from "mdb-react-ui-kit";
import { Handle } from "@xyflow/react";
import { useTranslation } from "react-i18next";

export default memo(({ data, isConnectable }) => {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  function openFilter() {
    data.actionExecutor({ action: 1 });
  }
  function onDelete(id) {
    data.onDelete(id);
  }
  const delteHandle = (id) => {
    data.actionExecutor({ action: 2, deleteHId: id, handles: data.handles });
    data.actionExecutor({ action: 15, value: id });
  };
  useEffect(() => {
    if (!data.handles || data.handles.length == 0) {
      data.handles = [
        {
          id: "minus1",
          name: "No Matches",
          label: "No Matches",
          deletable: false,
          top: 150,
          value: "minus1",
        },
      ];
    }
    data.actionExecutor({ action: -1 });
  }, []);

  const handleClick = (id) => {
    data.actionExecutor({ action: 20, editHId: id, handles: data.handles });
  };

  return (
    <>
      <div>
        <div className="callerIDNodeHeader">
          {data.label}
          <MDBIcon
            fas
            icon="times"
            className="cursor-pointer"
            color="light"
            onClick={() => onDelete()}
          />
        </div>
        <div className="nodeBody">
          <button
            className="btn-primary nodeButton"
            onClick={() => openFilter()}
          >
            <MDBIcon fas icon="filter" className="me-2" color="light" />
            Add Filter
          </button>
        </div>

        <Handle type="target" position="left" id="target"></Handle>
        <React.Fragment key={data.id}>
          {data.handles && Array.isArray(data.handles) &&
            data.handles.map((handle, index) => (
              <>
                <Handle
                  className=""
                  type="source"
                  position="right"
                  id={handle.id}
                  style={{
                    top: handle.top + (index + 1) * 20,
                    right: -1,
                    background: "#fff",
                    height: 10,
                    width: 10,
                    border: "2px solid #288cd4",
                  }}
                  isConnectable={true}
                >
                  {handle.id + "" == "minus1" && (
                    <>
                      {" "}
                      <div className="handletext">
                        <span>
                          No Matches
                        </span>
                      </div>
                    </>
                  )}{" "}
                  {handle.id + "" != "minus1" && (
                    <>
                      <div
                        className="handletext"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleClick(handle.id);
                        }}
                      >
                        <span>
                          {handle.label}
                        </span>
                        <div className="ms-3">
                          <div
                            size="sm"
                            className="p-0"
                            color="link"
                            onClick={(e) => {
                              e.stopPropagation();
                              delteHandle(handle.id);
                            }}
                          >
                            <MDBIcon fas icon="times" color="primary" />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </Handle>
              </>
            ))}
        </React.Fragment>
      </div>
    </>
  );
});
